import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

export const STEPS = [
	{ label: 'Select Plan', path: '/subscription-plan' },
	{ label: 'Billing Details', path: '/checkout' },
	{ label: 'Make Payment', path: '/payment' },
];

export const useStepper = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const currentStep = useMemo(() => {
		return STEPS.findIndex((step) => step.path === location.pathname);
	}, [location.pathname]);

	const goToStep = (index) => {
		const target = STEPS[index];
		const params = new URLSearchParams(location.search);
		params.set('step', target.label.toLowerCase().replace(/\s+/g, '-'));
		navigate(`${target.path}?${params.toString()}`);
	};

	return {
		steps: STEPS,
		currentStep,
		goToStep,
	};
};
